import { Main } from '../components'
import React from 'react'
import {
    Home,
    Admin,
    Blog,
    BuildAProject,
    Team,
    DetailedBlogs,
    DetailedProfile,
    BookACall,
    Services,
    SuccessStories,
    DetailedSuccess,
    WereHiring,
    DetailedWere,
    NotFound,
} from 'src/pages'
import { ROUTES_IDS, Routes } from './types'

export const routes: Routes = [
    {
        element: <Main />,
        routes: [
            {
                uid: ROUTES_IDS.HOME,
                path: '/',
                element: <Home />,
                exact: true,
            },
            {
                uid: ROUTES_IDS.ADMIN,
                path: '/admin',
                element: <Admin />,
                exact: true,
            },
            {
                uid: ROUTES_IDS.BLOG,
                path: '/blog',
                element: <Blog />,
                exact: true,
            },
            {
                uid: ROUTES_IDS.DETAILED_BLOG,
                path: '/blog/:id',
                element: <DetailedBlogs />,
                exact: true,
            },
            {
                uid: ROUTES_IDS.BUILD_PROJECT,
                path: '/buildToProject',
                element: <BuildAProject />,
                exact: true,
            },
            {
                uid: ROUTES_IDS.TEAM,
                path: '/team',
                element: <Team />,
                exact: true,
            },
            {
                uid: ROUTES_IDS.SUCCESS_STORIES,
                path: '/successStories',
                element: <SuccessStories />,
                exact: true,
            },
            {
                uid: ROUTES_IDS.DETAILED_SUCCESS,
                path: '/successStories/:title',
                element: <DetailedSuccess />,
            },
            {
                uid: ROUTES_IDS.SERVICES,
                path: '/services',
                element: <Services />,
                exact: true,
            },
            {
                uid: ROUTES_IDS.DETAILED_PROFILE,
                path: '/team/:name',
                element: <DetailedProfile />,
            },
            {
                uid: ROUTES_IDS.WERE_HIRING,
                path: '/wereHiring',
                element: <WereHiring />,
                exact: true,
            },
            {
                uid: ROUTES_IDS.DETAILED_WERE,
                path: '/wereHiring/:id',
                element: <DetailedWere />,
            },
            {
                uid: ROUTES_IDS.BOOK_A_CALL,
                path: '/bookACall',
                element: <BookACall />,
                exact: true,
            },
        ],
    },
    {
        path: '*',
        element: <NotFound />,
    },
]
